import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

/** Domain layout: one guard for the list and every child screen. */
export const Route = createFileRoute("/_authenticated/_care/residents")({
  beforeLoad: ({ context }) => guardRoute(context.me, "residents"),
  component: Outlet,
});
